export class CreatePropietarioResponse {

    public idPropietario!:number
    public id!: number

}
